import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AppConfig } from '../config/app.config';

/** Do not attach Bearer token to these paths (case-insensitive). */
const NO_AUTH_PATTERNS = ['/api/auth/login', '/api/auth/register', '/api/auth/refresh'];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly apiBase = AppConfig.apiBaseUrl;

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url = req.url;
    const isNoAuth = NO_AUTH_PATTERNS.some(p => url.includes(p));
    if (isNoAuth) {
      return next.handle(req);
    }

    const token = this.auth.getToken();
    const valid = token && !this.auth.isTokenExpired();
    let out = req;
    if (valid) {
      out = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
    }

    return next.handle(out).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.auth.logout();
        }
        if (err.status === 403) {
          console.warn('Access forbidden:', err.url);
        }
        return throwError(() => err);
      })
    );
  }
}
